import { render, staticRenderFns } from "./textNode.vue?vue&type=template&id=8caa4e8c&scoped=true&functional=true&"
import script from "./textNode.vue?vue&type=script&lang=js&"
export * from "./textNode.vue?vue&type=script&lang=js&"
import style0 from "./textNode.vue?vue&type=style&index=0&id=8caa4e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "8caa4e8c",
  null
  
)

export default component.exports